<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">Pasos para la portabilidad</h5>

    <div class="box-opts">
      <div class="box-opt" v-bind:class="{ active : portPersona == 'fisica' }" @click="portPersona = 'fisica'">
        <i></i> <span>Personas Físicas</span>
      </div>
      <div class="box-opt" v-bind:class="{ active : portPersona == 'moral' }" @click="portPersona = 'moral'">
        <i></i> <span>Personas Morales</span>
      </div>
    </div>

    <div class="d-block mt-3" v-if="portPersona == 'fisica'">
      <h5 class="subtitle">1. Obtén tu NIP</h5>
      <p>
        Puedes hacerlo en línea o envía un Mensaje de Texto (SMS) sin costo con la palabra NIP a la marcación 0XX, acude a un centro de atención a clientes donde te podrán ayudar.
      </p>

      <br />
      <h5 class="subtitle">2. Reúne los requisitos</h5>
      <p>
        Para ejercer tu derecho solo requieres el NIP vigente* y una identificación oficial que puede ser:
      </p>
      <ul>
        <li>Credencial para votar vigente expedida por el Instituto Federal Electoral (IFE) o por el Instituto Nacional Electoral (INE)</li>
        <li>Pasaporte vigente</li>
        <li>Cédula Profesional</li>
        <li>Cartilla del Servicio Militar Nacional</li>
        <li>Certificado de Matrícula Consular</li>
        <li>Documento migratorio vigente emitido por autoridad competente o, en su caso, prórroga o refrendo migratorio</li>
        <li>Identificaciones vigentes con fotografía y firma expedidas por la Federación, los Estados, el Distrito Federal o los Municipios (por ejemplo: IMSS, ISSTE, SEP, DIF, INAPAM)</li>
        <li>CURP (Clave Única de Registro de Población).</li>
      </ul>
      <p class="text-sm">
        *Una vez otorgado el NIP, este tendrá una vigencia de 5 días a partir de la fecha en que fue solicitado.<br />
        Nota: para menores de edad se acepta como identificación, aquella que sea vigente con fotografía y firma expedida por la Federación, los Estados, el Distrito Federal o los Municipios.
      </p>

      <br />
      <h5 class="subtitle">3. Acude a un punto de contacto</h5>
      <p>
        Una vez capturado tu trámite de portabilidad, recibirás dos Mensajes de Texto (SMS) en tu línea: el primero informándote que tu trámite está en validación e indicándote el Folio de portabilidad con el que podrás consultar el estatus de tu trámite, y el segundo informándote la fecha de ejecución de tu portación. Consulta el estatus de tu trámite.
      </p>

      <br />
      <h5 class="subtitle">4. Al realizar tu trámite en línea acude a un Centro de Atención a Clientes Skycel donde se te entregará tu Sim Card.</h5>
      <p>
        Si tu portabilidad la generaste por otro medio, una vez ejecutada la fecha de portación, acude a un Centro de Atención a Clientes Skycel donde se entregará un Chip (SIM Card) el cual deberás insertar en tu teléfono una vez que se ejecute tu portabilidad.<br />
        Además, para la Ciudad de México, Hidalgo, Morelos y Estado de México también puedes acudir con nuestros Distribuidores Autorizados.
      </p>
    </div>

    <div class="d-block mt-3" v-if="portPersona == 'moral'">
      <h5 class="subtitle">1. Reúne los requisitos:</h5>
      <p>
        El trámite solo podrá ser realizado por el Representante Legal o Apoderado de la empresa, quien deberá presentar:
      </p>
      <ul>
        <li>Poder Notarial que conste en escritura pública.</li>
        <li>
          Identificación oficial que puede ser:
          <ul>
            <li>Credencial para votar vigente expedida por el Instituto Federal Electoral (IFE) o por el Instituto Nacional Electoral (INE)</li>
            <li>Pasaporte vigente</li>
            <li>Cédula Profesional</li>
            <li>Cartilla del Servicio Militar Nacional</li>
            <li>Certificado de Matrícula Consular</li>
            <li>Documento migratorio vigente emitido por autoridad competente, en su caso, prórroga o refrendo migratorio</li>
            <li>Identificaciones vigentes con fotografía y firma, expedida por la Federación, los Estados, el Distrito Federal o los Municipios (por ejemplo: IMSS, ISSTE, SEP, DIF, INAPAM)</li>
          </ul>
          <p>
            Para dependencias, entidades gubernamentales, sujetos u órganos de derecho público es la Identificación Oficial del funcionario en conjunto con la documentación que acredite que el funcionario cuenta con facultades para realizar procesos de contratación para la adquisición de servicios a nombre de la dependencia.
          </p>
        </li>
      </ul>

      <br />
      <h5 class="subtitle">2. Si ya eres cliente Skycel, contacta a tu Ejecutivo de Cuenta o ingresa a Skycel Empresas.</h5>
      <p>
        2.1 Si aún no eres cliente ingresa a Skycel Empresas, proporciona tus datos y te contactaremos lo antes posible. Si ya eres cliente contacta a tu Ejecutivo.
      </p>
      <p class="mt-2">
        Proporciona al Ejecutivo de Cuenta la información que te solicite para el llenado de la Solicitud de Portabilidad.
      </p>
      <p class="mt-2">
        2.2 El Ejecutivo de Cuenta agendará una fecha para visitarte, momento en el que deberás presentar el Poder Notarial, tu identificación oficial y firmar la solicitud que el Ejecutivo llevará previamente llenada.
      </p>

      <br />
      <h5 class="subtitle">3. Una vez firmada la Solicitud e ingresada al sistema, recibirás dos Mensajes de Texto (SMS) en cada una de las líneas a portar: el primero informando que el trámite esta en proceso e indicando el ID de portabilidad con el que podrás consultar el estatus del trámite de dicha línea, y el segundo informando la fecha de ejecución de la portación de dicha línea.</h5>
      <p>
        <a target="_blank" href="https://www.portabilidad.mx/">Consulta el estatus del trámite.</a>
      </p>

      <br />
      <h5 class="subtitle">4. En la misma visita el Ejecutivo de Cuenta te entregará un Chip (SIM card) por línea que deseas portar, los cuales deberán insertarse en los equipos una vez que se ejecute la portabilidad para poder disfrutar de los servicios de Skycel.</h5>

      <p class="mt-3 text-sm">
        Nota 1: En caso de que tu Solicitud de Portabilidad sea rechazada recibirás de Skycel un Mensaje de Texto (SMS) notificándotelo, a fin de que acudas nuevamente a un punto de contacto Skycel para corregir el motivo que haya originado el rechazo.
      </p>
      <p class="mt-2 text-sm">
        Nota 2: Como regla general, en caso de realizar tu portabilidad en horario y día hábil, ésta se programará para ejecución a las 2:00 a.m. del día siguiente. En caso que requieras que ésta se realice en una fecha distinta posterior, podrás elegir la fecha efectiva de la portabilidad la cual no podrá exceder de 5 días hábiles a partir de que ingreses tu solicitud.
      </p>
      <p class="mt-2 text-sm">
        RESOLUCIÓN IFT.DOF 12/11/14
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      portPersona: 'fisica',
    }
  },
}
</script>
